import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Book Magazine Editions',
  basePath: '/book-magazine-editions',
  rowKey: 'pid',
  columns: [
    { key: 'country_name', label: 'Country', sortable: true },
    { key: 'title', label: 'Title', sortable: true },
    { key: 'hint', label: 'Subscription Hint', sortable: true },
    { key: 'max_editions', label: 'Max Editions/Year', sortable: true },
    { key: 'subscription', label: 'Subscription', sortable: true,
      render: (v) => v == 1 ? 'Yes' : 'No' },
    { key: 'subscription_price', label: 'Subscription Price', sortable: true },
    { key: 'delivery_local_cost', label: 'Delivery Cost', sortable: true },
  ],
  fields: [
    { key: 'pid', label: 'ID', type: 'hidden' },
    { key: 'country', label: 'Country', type: 'async-select',
      optionsUrl: '/countries/options', required: true },
    { key: 'title', label: 'Title', type: 'text' },
    { key: 'hint', label: 'Subscription Hint', type: 'text' },
    { key: 'max_editions', label: 'Max Editions/Year', type: 'number' },
    { key: 'subscription_price', label: 'Subscription Price', type: 'number' },
    { key: 'delivery_local_cost', label: 'Payment at Delivery Cost', type: 'number' },
    { key: 'subscription', label: 'Subscription', type: 'yesno', defaultValue: '0' },
  ],
  defaultSort: { field: 'country_name', dir: 'asc' },
});
